var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({class:[
		{ 'loading': _vm.indeterminate },
		'app-button' ],on:{"click":function($event){_vm.$emit('click-image')}}},'button',_vm.$attrs,false),[(_vm.ifNumber)?_c('div',{staticClass:"button-number",style:(("background: " + (_vm.globalColors.primary) + ";"))},[_vm._v(_vm._s(_vm.number))]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":_vm.indeterminate ? '' : _vm.imageUser,"alt":_vm.data.name,"height":_vm.data.height || 20}}),_vm._v("\n\t"+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fadbbf3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/buttons/app-button-image.vue
// module id = 475
// module chunks = 33